<template>
  <div />
</template>

<script>
import { createWidget } from '@typeform/embed'
import '@typeform/embed/build/css/widget.css'

export default {
  name: 'TypeForm',

  props: {
    url: {
      type: String,
      required: true
    },
    hideHeaders: {
      type: Boolean,
      default: true
    },
    hideFooter: {
      type: Boolean,
      default: true
    },
    opacity: {
      type: Number,
      default: 100
    },
    buttonText: {
      type: String,
      default: undefined
    },
    onSubmit: {
      type: Function,
      default: undefined
    }
  },
  mounted () {
    const formId = this.url.split('to/')[1]
    createWidget(formId, {
      container: this.$el,
      hideHeaders: this.hideHeaders,
      hideFooter: this.hideFooter,
      opacity: this.opacity,
      buttonText: this.buttonText,
      onSubmit: this.onSubmit,
      iframeProps: {
        style: 'border-radius: 0'
      }
    })
  }
}
</script>
